<template>
  <div aria-hidden="true">
    <div class="w-4 h-4 bg-gray-light rounded-full flex justify-center items-center">
      <div class="w-2.5 h-2.5 bg-red rounded-full animate-pulse flex-none"></div>
    </div>
  </div>
</template>
